const stats = [
  { num: "3,500+", label: "累计搞笑合集", icon: "ri-stack-line" },
  { num: "100+", label: "每日持续更新", icon: "ri-refresh-line" },
  { num: "500万+", label: "乐子人聚集地", icon: "ri-team-line" },
  { num: "960+", label: "神吐槽段子", icon: "ri-message-3-line" },
];

export default function Stats() {
  return (
    <section className="w-full bg-primary-500 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center text-center">
              <span className="grid h-12 w-12 items-center justify-center rounded-full bg-background-50/15 text-2xl text-background-50">
                <i className={s.icon}></i>
              </span>
              <div className="mt-3 font-heading text-3xl text-background-50 md:text-4xl">{s.num}</div>
              <div className="mt-1 text-sm text-background-100">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}